export const GET_PACKAGING_MASTER = 'GET_PACKAGING_MASTER';
export const GET_PACKAGING_MASTER_SUCCESS = 'GET_PACKAGING_MASTER_SUCCESS';
export const GET_PACKAGING_MASTER_FAILED = 'GET_PACKAGING_MASTER_FAILED';

export const ADD_PACKAGING_MASTER = 'ADD_PACKAGING_MASTER';
export const ADD_PACKAGING_MASTER_SUCCESS = 'ADD_PACKAGING_MASTER_SUCCESS';
export const ADD_PACKAGING_MASTER_FAILED = 'ADD_PACKAGING_MASTER_FAILED';

export const EDIT_PACKAGING_MASTER = 'EDIT_PACKAGING_MASTER';
export const EDIT_PACKAGING_MASTER_SUCCESS = 'EDIT_PACKAGING_MASTER_SUCCESS';
export const EDIT_PACKAGING_MASTER_FAILED = 'EDIT_PACKAGING_MASTER_FAILED';

export const DELETE_PACKAGING_MASTER = 'DELETE_PACKAGING_MASTER';
export const DELETE_PACKAGING_MASTER_SUCCESS = 'DELETE_PACKAGING_MASTER_SUCCESS';
export const DELETE_PACKAGING_MASTER_FAILED = 'DELETE_PACKAGING_MASTER_FAILED';
